/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { forgotPasswordConfirmPostRequestSchema } from './forgotPasswordConfirmPostRequestSchema.ts';
import { forgotPasswordConfirmPostResponseSchema } from './forgotPasswordConfirmPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postForgotPasswordConfirm200Schema = z.lazy(() => forgotPasswordConfirmPostResponseSchema);

/**
 * @description 505 response
 */
export const postForgotPasswordConfirm505Schema = z.any();

export const postForgotPasswordConfirmMutationRequestSchema = z.lazy(() => forgotPasswordConfirmPostRequestSchema);

export const postForgotPasswordConfirmMutationResponseSchema = z.lazy(() => postForgotPasswordConfirm200Schema);
